import React from 'react';
import { useNavigate } from 'react-router-dom';

const ProgramSummary = ({ programData, showEditButton, editButtonText, editRoute }) => {
  const navigate = useNavigate();
  
  const totalLearners = programData.groups.reduce(
    (total, group) => total + group.learners.length, 0
  );
  
  const totalModules = programData.groups.reduce(
    (total, group) => total + group.learners.reduce(
      (groupTotal, learner) => groupTotal + learner.modules.length, 0
    ), 0
  );

  return (
    <div className="summary-box" data-testid="program-summary">
      {programData.groups.map(group => (
        <div key={group.name} className="mb-6">
          <h4 className="font-semibold mb-2 text-[#2d2d2d]">{group.name}</h4>
          <div className="space-y-2">
            {group.learners.map((learner, index) => (
              <div key={index} className="mb-4 p-3 bg-[#f7f8fa] rounded-lg">
                <div className="font-medium mb-2 text-[#2d2d2d]">{learner.name}</div>
                <div className="flex gap-2 flex-wrap">
                  {learner.modules.map(module => {
                    const moduleClass = `module-${module.module_id}`;
                    return (
                      <div
                        key={module.module_id}
                        className={`${moduleClass} px-2 py-1 rounded text-xs font-medium flex-shrink-0`}
                        title={module.module_name}
                      >
                        {module.module_id}. {module.module_name}
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
      
      {showEditButton && (
        <div className="mt-auto pt-4">
          <button
            onClick={() => navigate(editRoute)}
            className="btn-secondary w-full"
            data-testid="edit-program-button"
          >
            {editButtonText}
          </button>
        </div>
      )}
    </div>
  );
};

export default ProgramSummary;